import {Component, ViewChild, Input, OnInit, Inject, PLATFORM_ID, OnChanges} from '@angular/core';
import {timer} from 'rxjs';
import {first} from 'rxjs/operators';
import {VirtualScrollerComponent} from 'ngx-virtual-scroller';
import {isPlatformBrowser} from '@angular/common';
import {countryConfig} from 'src/country-config/country-config';
import {BrowserDetectorService} from '../../../../data/networking/services/shared/broswer-detector/browser-detector.service';
import {Banner} from '../../../../data/networking/models/cms/responses/banner-res';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit, OnChanges {
  countryConfig = countryConfig;
  optionsArrows = true;
  scrollPixel = 0;
  scrollToItem = 0;
  nextItems = 0;
  arrows = {
    left: {
      disabled: true,
      show: true,
    },
    right: {
      disabled: false,
      show: true,
    },
  };
  @Input() banners: Array<Banner>;
  @Input() options: any;
  @Input() dataLoaded = false;
  @Input() customClasses: string;
  @Input() aPlay: boolean;
  @Input() bannerLogin = false;
  @Input() bannerNewHome = true;
  @Input() isCategory = false;
  lazyLoad = true;
  interval;
  browser;
  placeholderImg;
  isBrowser;
  public isMobile: boolean;
  public startItem: number;
  @ViewChild(VirtualScrollerComponent)
  private virtualScroller: VirtualScrollerComponent;

  constructor(private browserDetector: BrowserDetectorService,
              @Inject(PLATFORM_ID) platformId) {
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);
    this.startItem = 1;
  }

  autoplay() {
    if (this.isBrowser) {
      this.interval = setInterval(() => {
        if ( this.scrollToItem < this.banners?.length ) {
          this.scrollToItem += this.nextItems;
          this.scrollTo();
        }
      }, 5000);
    }
  }

  next() {
    clearInterval(this.interval);
    if (!this.arrows.right.disabled && this.customClasses !== 'circle' ) {
      this.scrollToItem += this.nextItems;
      this.scrollTo();
    }

    if(!this.arrows.right.disabled && this.customClasses && this.customClasses === 'circle'){
      this.scrollToItem = this.scrollToItem + ((this.scrollToItem === this.virtualScroller['_items'].length - 1 ) ? 2 : 1);
      this.scrollTo();
    }
  }

  back() {
    clearInterval(this.interval);
    if (!this.arrows.left.disabled &&  this.customClasses !== 'circle') {
      this.scrollToItem -= this.nextItems;
      this.scrollTo();
    }

    if(!this.arrows.left.disabled && this.customClasses && this.customClasses === 'circle'){
      if(this.scrollToItem === this.virtualScroller['_items'].length + 1){
        this.scrollToItem -= 2;
      }else{
        this.scrollToItem -= 1;
      }
      this.scrollTo();
    }
  }

  scrollTo() {
    if (this.virtualScroller) {
      this.virtualScroller.scrollInto(this.virtualScroller.items[ this.scrollToItem ], true, 0, 450);
    }

    if (this.virtualScroller && this.customClasses && this.customClasses === 'circle') {
      this.virtualScroller.scrollInto(this.scrollToItem , null, null, 450, () => {});
    }
  }

  setStartItems(){
    if(screen.width <= 1200){
      this.isMobile = true;
    }

    if(!this.isMobile){
      if(this.customClasses && this.customClasses === 'circle'){
        this.startItem = (this.banners?.length / 2) + 2;
      }
    }else{
      if(this.customClasses && this.customClasses === 'circle' || this.customClasses && this.customClasses === 'square'){
        this.startItem = 1;
      }
    }
  }

  eventScroll(event) {
    if (this.optionsArrows && event.endIndex === 0) {
      this.nextItems = this.startItem;
      this.scrollToItem = event.endIndex;
      this.optionsArrows = false;
    }
    if (event.endIndex === this.scrollToItem) {
      clearInterval(this.interval);
    }
    if (this.banners) {
      if (event.endIndex > this.nextItems && event.endIndex <= this.banners.length - 1) {
        this.arrows.left.disabled = false;
        this.arrows.right.disabled = false;
      }
      if (event.endIndex === this.banners.length - 1) {
        this.arrows.right.disabled = true;
      }
    }
    if (event.startIndex === 0 && event.scrollStartPosition === 0) {
      this.arrows.left.disabled = true;
    }

  }

  updatePlaceHolder() {
    this.browser = this.isBrowser ? this.browserDetector.checkBrowser() : null;
    const width = this.isBrowser ? (window.innerWidth < 600 ? 945 : 1350) : 0;
    let imgSuffix = this.isBrowser ? `=s${width}` : '=s1500';
    imgSuffix += this.browser && (this.browser.chrome || this.browser.firefox) ? '-rw' : '';
    const placeholderImg = 'https://lh3.googleusercontent.com/'
      + 'cQitSofwR512nLZJmxGJa9tBRAZx7tldtdPler_KjI-8BZo-tk3f4kRg11BfTGlG-3KdqBsQdG-Ck5DpptgcyJ2tf_dnBOClNQ';
    let banner = this.banners && this.banners.length > 0
      ? this.banners[0].urlBanner.replace(/=s1500/g, '').replace(/-rw/g, '')
      : '';
    const idx = banner.indexOf('=s');
    banner = idx >= 0 ? banner.substr(0, idx) : banner;

    this.placeholderImg = banner ? `${banner}${imgSuffix}` : `${placeholderImg}${imgSuffix}`;
  }

  ngOnInit() {
    this.setStartItems();


    if (this.isBrowser) {
      this.updatePlaceHolder();
      timer(500)
        .pipe(first())
        .subscribe(() => {
          this.lazyLoad = false;
        });
      setTimeout(() => {
        if(this.aPlay === true){
          this.autoplay();
        }
      }, 4000);
    }
  }

  ngOnChanges(): void {
    this.updatePlaceHolder();
  }
}
